<template>
  <div
    class="vendor-service-item-container glass-tab-page"
    :class="{ 'vendor-service-item-container--modal': isModal }"
  >
    <BrucdcumHeader v-if="!isModal" :breadcrumb="['Vendor', 'Vendor Service Item']" />
    <form class="vendor-service-item-form" @submit.prevent>
      <div class="glass-tab-view vendor-service-item-glass-shell">
        <div class="glass-tab-view__tabs">
          <TabNavigation
            v-model="activeTab"
            :tabs="tabs"
            @update:modelValue="handleTabChange"
          />
        </div>

        <div class="glass-tab-view__content">
          <div v-if="activeTab === 'basic'" class="glass-tab-view__panel">
            <div class="glass-tab-panel glass-tab-panel--flex-column glass-tab-panel--stagger-rows">
              <div class="glass-tab-panel__row vendor-service-item-form-group-row">
                <div class="vendor-service-item-form-group vendor-service-item-form-group--label-input vendor-service-item-required">
                  <LabelInputField
                    input-id="vendor-service-name"
                    label="Service Name"
                    v-model="serviceName"
                    placeholder="Service Name"
                    flex
                    required
                  />
                </div>
                <div class="vendor-service-item-form-group vendor-service-item-form-group--label-dropdown">
                  <LabelDropdown
                    label="Category"
                    select-id="vendor-service-items-group"
                    v-model="itemsGroup"
                    flex
                    wide
                    :searchable="true"
                    :options="itemsGroupDropdownOptions"
                    @change="handleItemsGroupChange"
                  />
                  <div class="vendor-service-item-input-helper-text">e.g. Maintenance, Rent, Subscription</div>
                </div>
              </div>

              <div class="glass-tab-panel__row vendor-service-item-form-group-row vendor-service-item-form-group-row--checkboxes">
                <div class="vendor-service-item-form-group vendor-service-item-form-group--label-checkbox">
                  <LabelCheckboxField
                    input-id="vendor-service-is-subitem"
                    label="Subitem of"
                    v-model="isSubitem"
                    flex
                  />
                </div>
                <div class="vendor-service-item-form-group vendor-service-item-form-group--label-checkbox">
                  <LabelCheckboxField
                    input-id="vendor-service-taxable"
                    label="Taxable"
                    v-model="taxable"
                    flex
                  />
                </div>
                <div class="vendor-service-item-form-group vendor-service-item-form-group--label-checkbox">
                  <LabelCheckboxField
                    input-id="vendor-service-commission"
                    label="Commission item"
                    v-model="commissionItem"
                    flex
                  />
                </div>
                <div class="vendor-service-item-form-group vendor-service-item-form-group--label-checkbox">
                  <LabelCheckboxField
                    input-id="vendor-service-active"
                    label="Active"
                    v-model="active"
                    flex
                  />
                </div>
              </div>

              <div v-if="isSubitem" class="glass-tab-panel__row vendor-service-item-form-group-row">
                <div class="vendor-service-item-form-group vendor-service-item-form-group--label-dropdown vendor-service-item-required">
                  <LabelDropdown
                    label="Parent Item"
                    select-id="vendor-service-parent-item"
                    v-model="subitemOf"
                    flex
                    wide
                    required
                    :searchable="true"
                    :options="parentItemDropdownOptions"
                  />
                </div>
              </div>
            </div>
          </div>

          <div v-if="activeTab === 'service'" class="glass-tab-view__panel">
            <div class="glass-tab-panel glass-tab-panel--flex-column glass-tab-panel--stagger-rows">
              <div class="glass-tab-panel__row vendor-service-item-form-group-row vendor-service-item-form-group-row--checkboxes">
                <div class="vendor-service-item-form-group vendor-service-item-form-group--label-checkbox">
                  <LabelCheckboxField
                    input-id="vendor-service-sell"
                    label="I sell this service"
                    v-model="iSellThisService"
                    flex
                  />
                </div>
                <div class="vendor-service-item-form-group vendor-service-item-form-group--label-checkbox">
                  <LabelCheckboxField
                    input-id="vendor-service-buy"
                    label="I buy this service"
                    v-model="iBuyThisService"
                    flex
                    disabled
                  />
                </div>
              </div>

              <div v-if="iSellThisService || iBuyThisService" class="vendor-service-item-service-config glass-tab-panel--nested">
                <div v-if="iSellThisService" class="vendor-service-item-service-column">
                  <h4 class="vendor-service-item-service-header">Sell Service Configuration</h4>
                  <div class="vendor-service-item-form-group-row">
                    <div
                      class="vendor-service-item-form-group vendor-service-item-form-group--label-input"
                      :class="{ 'vendor-service-item-required': iSellThisService }"
                    >
                      <LabelInputField
                        input-id="vendor-service-sales-price"
                        label="Sales Price(USD)"
                        v-model="salesPrice"
                        placeholder="0.00"
                        flex
                        :required="iSellThisService"
                        :disabled="!iSellThisService"
                        :has-error="!!salesPriceError"
                        @input="validatePrices"
                      >
                        <div v-if="salesPriceError" class="vendor-service-item-error-text">{{ salesPriceError }}</div>
                      </LabelInputField>
                    </div>
                    <div
                      class="vendor-service-item-form-group vendor-service-item-form-group--label-dropdown"
                      :class="{ 'vendor-service-item-required': iSellThisService }"
                    >
                      <LabelDropdown
                        label="Income Account"
                        select-id="vendor-service-income-account"
                        v-model="incomeAccount"
                        flex
                        wide
                        :searchable="true"
                        :required="iSellThisService"
                        :disabled="!iSellThisService"
                        :options="incomeAccountDropdownOptions"
                        @change="handleIncomeAccountChange"
                      />
                      <button
                        v-if="incomeAccount === '__add_new_account__'"
                        type="button"
                        class="vendor-service-item-action-btn"
                        @click.prevent="navigateToNewAccount"
                      >
                        Go to Add New Account
                      </button>
                    </div>
                  </div>
                  <div class="vendor-service-item-form-group vendor-service-item-form-group--label-input">
                    <LabelInputField
                      input-id="vendor-service-standard-cost"
                      label="Standard Cost(USD)"
                      v-model="standardCost"
                      placeholder="0.00"
                      flex
                    />
                  </div>
                  <div class="vendor-service-item-form-group-row vendor-service-item-form-group-row--full">
                    <div class="vendor-service-item-form-group vendor-service-item-form-group--label-description">
                      <LabelDescriptionField
                        input-id="vendor-service-sales-description"
                        label="Description on Sales Transaction"
                        v-model="salesDescription"
                        placeholder="Description on sales transaction"
                        :rows="2"
                        :disabled="!iSellThisService"
                        flex
                      />
                    </div>
                  </div>
                </div>

                <div v-if="iBuyThisService" class="vendor-service-item-service-column">
                  <h4 class="vendor-service-item-service-header">Buy Service Configuration</h4>
                  <div class="vendor-service-item-form-group-row">
                    <div
                      class="vendor-service-item-form-group vendor-service-item-form-group--label-input"
                      :class="{ 'vendor-service-item-required': iBuyThisService }"
                    >
                      <LabelInputField
                        input-id="vendor-service-purchase-price"
                        label="Purchase Price(USD)"
                        v-model="purchasePrice"
                        placeholder="0.00"
                        flex
                        :required="iBuyThisService"
                        :disabled="!iBuyThisService"
                        :has-error="!!purchasePriceError"
                        @input="validatePrices"
                      >
                        <div v-if="purchasePriceError" class="vendor-service-item-error-text">{{ purchasePriceError }}</div>
                      </LabelInputField>
                    </div>
                    <div
                      class="vendor-service-item-form-group vendor-service-item-form-group--label-dropdown"
                      :class="{ 'vendor-service-item-required': iBuyThisService }"
                    >
                      <LabelDropdown
                        label="Expense Account"
                        select-id="vendor-service-expense-account"
                        v-model="expenseAccount"
                        flex
                        wide
                        :searchable="true"
                        :required="iBuyThisService"
                        :disabled="!iBuyThisService"
                        :options="expenseAccountDropdownOptions"
                        @change="handleExpenseAccountChange"
                      />
                      <button
                        v-if="expenseAccount === '__add_new_account__'"
                        type="button"
                        class="vendor-service-item-action-btn"
                        @click.prevent="navigateToNewAccount"
                      >
                        Go to Add New Account
                      </button>
                    </div>
                  </div>
                  <div class="vendor-service-item-form-group-row">
                    <div class="vendor-service-item-form-group vendor-service-item-form-group--label-dropdown">
                      <LabelDropdown
                        label="Preferred Vendor"
                        select-id="vendor-service-preferred-vendor"
                        v-model="preferredVendor"
                        flex
                        wide
                        :searchable="true"
                        :disabled="!iBuyThisService"
                        :options="preferredVendorDropdownOptions"
                        @change="handlePreferredVendorChange"
                      />
                    </div>
                    <div class="vendor-service-item-form-group vendor-service-item-form-group--label-input">
                      <LabelInputField
                        input-id="vendor-service-vendor-no"
                        label="Vendor Service No"
                        v-model="vendorServiceNo"
                        placeholder="Vendor Service No"
                        flex
                        :disabled="!iBuyThisService"
                      />
                    </div>
                  </div>
                  <div class="vendor-service-item-form-group-row vendor-service-item-form-group-row--full">
                    <div class="vendor-service-item-form-group vendor-service-item-form-group--label-description">
                      <LabelDescriptionField
                        input-id="vendor-service-purchase-description"
                        label="Description on Purchase Transaction"
                        v-model="purchaseDescription"
                        placeholder="Description on purchase transaction"
                        :rows="2"
                        :disabled="!iBuyThisService"
                        flex
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="vendor-service-item-form-actions glass-tab-view__actions">
        <template v-if="isModal && activeTab === 'service'">
          <SecondaryButton label="Cancel" icon="bi bi-x-lg" @click="cancel" />
          <PrimaryButton label="Save and Continue" icon="bi bi-check-lg" @click="handleModalSave" />
        </template>
        <template v-else-if="isModal">
          <SecondaryButton label="Cancel" icon="bi bi-x-lg" @click="cancel" />
          <PrimaryButton label="Next" icon="bi bi-arrow-right" @click="handleNext" />
        </template>
        <template v-else-if="activeTab === 'service'">
          <SecondaryButton label="Cancel" icon="bi bi-x-lg" @click="cancel" />
          <PrimaryButton label="Save and New" @click="handleSaveAndNew" />
          <PrimaryButton label="Save and Close" @click="handleSaveAndClose" />
        </template>
        <template v-else>
          <SecondaryButton label="Cancel" icon="bi bi-x-lg" @click="cancel" />
          <PrimaryButton label="Next" icon="bi bi-arrow-right" @click="handleNext" />
        </template>
      </div>
    </form>

    <AddNewItemGroup
      :visible="showAddGroupModal"
      :companyId="companyId"
      item-type="Service"
      @ok="onAddGroupOk"
      @cancel="onAddGroupCancel"
    />
    <VendorDetailsSearch v-if="showVendorSearchModal" @close="closeVendorSearchModal" />

    <ErrorModal
      :show="showErrorModal"
      :title="errorTitle"
      :message="errorMessage"
      :button-text="errorButtonText"
      @close="closeErrorModal"
    />

    <SuccessModal
      :show="showSuccessModal"
      :title="successTitle"
      :message="successMessage"
      :button-text="successButtonText"
      @close="closeSuccessModal"
    />

    <ProfitLossModal
      :visible="showProfitLossModal"
      :profit-loss-data="profitLossData"
      :auto-close="false"
      :close-on-overlay-click="true"
      @close="closeProfitLossModal"
    />
  </div>
</template>

<script>
import '../styles/VendorServiceItem.css';
import '../styles/vendor-service-item-glass.css';
import BrucdcumHeader from '@/components/BrucdcumHeader.vue';
import TabNavigation from '@/components/TabNavigation.vue';
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/SuccessModal.vue';
import ProfitLossModal from '@/components/ProfitLossModal.vue';
import VendorDetailsSearch from '@/modules/vendor/views/VendorDetailsSearch.vue';
import ApiService from '@/services/api.service.js';
import CompanyService from '@/services/company.service.js';
import AddNewItemGroup from '@/modules/company/views/AddNewItemGroup.vue';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';
import LabelInputField from '@/modules/consultant/components/LabelInputField.vue';
import LabelDropdown from '@/modules/consultant/components/LabelDropdown.vue';
import LabelCheckboxField from '@/modules/consultant/components/LabelCheckboxField.vue';
import LabelDescriptionField from '@/modules/consultant/components/LabelDescriptionField.vue';

export default {
  name: 'VendorServiceItem',
  components: {
    BrucdcumHeader,
    TabNavigation,
    ErrorModal,
    SuccessModal,
    ProfitLossModal,
    VendorDetailsSearch,
    AddNewItemGroup,
    PrimaryButton,
    SecondaryButton,
    LabelInputField,
    LabelDropdown,
    LabelCheckboxField,
    LabelDescriptionField,
  },
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    companyIdOverride: {
      type: [String, Number],
      default: '',
    },
    preferredVendorId: {
      type: [String, Number],
      default: '',
    },
  },
  emits: ['saved', 'close'],
  data() {
    return {
      tabs: [
        { id: 'basic', name: 'Basic Information' },
        { id: 'service', name: 'Service Information' },
      ],
      activeTab: 'basic',
      serviceName: '',
      isSubitem: false,
      subitemOf: '',
      iSellThisService: false,
      salesDescription: '',
      salesPrice: 0.0,
      incomeAccount: '',
      taxable: true,
      commissionItem: false,
      standardCost: 0.0,
      itemsGroup: '',
      active: true,
      iBuyThisService: true,
      purchaseDescription: '',
      purchasePrice: 0.0,
      expenseAccount: '',
      preferredVendor: '',
      vendorServiceNo: '',
      showVendorSearchModal: false,
      incomeAccounts: [],
      expenseAccounts: [],
      vendorsList: [],
      itemCategories: [],
      showAddGroupModal: false,
      previousItemsGroup: '',
      salesPriceError: '',
      purchasePriceError: '',
      serviceItemsList: [],
      showErrorModal: false,
      errorTitle: 'Validation Error',
      errorMessage: '',
      errorButtonText: 'OK',
      showSuccessModal: false,
      successTitle: 'Success',
      successMessage: '',
      successButtonText: 'OK',
      saveAction: null,
      showProfitLossModal: false,
      profitLossData: {
        type: 'profit',
        amount: 0,
        percentage: 0,
        message: '',
      },
    };
  },
  computed: {
    companyId() {
      return this.companyIdOverride || this.$route.params.id;
    },
    itemsGroupDropdownOptions() {
      return [
        { value: '', label: 'Select category' },
        ...(this.itemCategories || []).map((group) => ({
          value: String(group.id),
          label: group.name,
        })),
        { value: '__create_new__', label: 'Add New Category' },
      ];
    },
    parentItemDropdownOptions() {
      return [
        { value: '', label: 'Select parent item' },
        ...(this.serviceItemsList || []).map((item) => ({
          value: String(item.id),
          label: item.serviceName,
        })),
      ];
    },
    incomeAccountDropdownOptions() {
      return [
        { value: '', label: 'Select account' },
        ...(this.incomeAccounts || []).map((acc) => ({
          value: String(acc.id),
          label: `${acc.accountNumber} - ${acc.accountName} - ${acc.accountType}`,
        })),
        { value: '__add_new_account__', label: 'Add New Account' },
      ];
    },
    expenseAccountDropdownOptions() {
      return [
        { value: '', label: 'Select account' },
        ...(this.expenseAccounts || []).map((acc) => ({
          value: String(acc.id),
          label: `${acc.accountNumber} - ${acc.accountName} - ${acc.accountType}`,
        })),
        { value: '__add_new_account__', label: 'Add New Account' },
      ];
    },
    preferredVendorDropdownOptions() {
      return [
        { value: '', label: 'Select vendor' },
        ...(this.vendorsList || []).map((vendor) => ({
          value: String(vendor.id),
          label: vendor.vendorName || vendor.name,
        })),
        { value: '__add_new_vendor__', label: 'Add New Vendor' },
      ];
    },
  },
  watch: {
    salesPrice: 'validatePrices',
    purchasePrice: 'validatePrices',
    iSellThisService() {
      this.validatePrices();
    },
    iBuyThisService() {
      this.validatePrices();
    },
    isSubitem(val) {
      if (!val) {
        this.subitemOf = '';
      }
    },
  },
  async created() {
    this.validatePrices();
    try {
      const res = await ApiService.getCompanyAccounts(this.companyId);
      const allAccounts = res.data.accounts || res.data || [];
      this.incomeAccounts = allAccounts.filter((a) => ['Income', 'Other Income'].includes(a.accountType));
      this.expenseAccounts = allAccounts.filter((a) =>
        ['Expense', 'Other Expense', 'Cost of Goods Sold'].includes(a.accountType),
      );
      const vendors = await ApiService.getAllVendors(this.companyId);
      this.vendorsList = Array.isArray(vendors) ? vendors : [];
      const itemCategories = await CompanyService.getAllItemGroups(this.companyId, 'Service');
      this.itemCategories = Array.isArray(itemCategories) ? itemCategories : [];
      const serviceItemsRes = await ApiService.get(`/vendor/service-items/company/${this.companyId}`);
      this.serviceItemsList = Array.isArray(serviceItemsRes.data) ? serviceItemsRes.data : [];
      if (this.preferredVendorId) {
        this.preferredVendor = String(this.preferredVendorId);
      }
    } catch (e) {
      this.incomeAccounts = [];
      this.expenseAccounts = [];
      this.vendorsList = [];
      this.itemCategories = [];
      this.serviceItemsList = [];
    }
  },
  methods: {
    resolveSelectValue(eventOrValue) {
      if (eventOrValue != null && typeof eventOrValue === 'object' && 'target' in eventOrValue) {
        return eventOrValue.target.value;
      }
      return eventOrValue;
    },
    handleTabChange(newTab) {
      this.activeTab = newTab;
    },
    handleNext() {
      const validationErrors = this.validateCurrentTab();
      if (Object.keys(validationErrors).length > 0) {
        this.showValidationError(validationErrors);
        return;
      }
      const tabs = ['basic', 'service'];
      const currentIndex = tabs.indexOf(this.activeTab);
      if (currentIndex < tabs.length - 1) {
        this.activeTab = tabs[currentIndex + 1];
      }
    },
    validateCurrentTab() {
      const errors = {};
      if (this.activeTab === 'basic') {
        if (!this.serviceName || this.serviceName.trim() === '') {
          errors.serviceName = 'Service Name is required.';
        }
        if (this.isSubitem && (!this.subitemOf || this.subitemOf === '')) {
          errors.subitemOf = 'Parent Item is required when Subitem is selected.';
        }
      } else if (this.activeTab === 'service') {
        if (!this.iSellThisService && !this.iBuyThisService) {
          errors.serviceType = 'Please select at least one service type (I sell this service or I buy this service).';
        }
        if (this.iSellThisService) {
          if (!this.salesPrice || this.salesPrice === '' || this.salesPrice === 0) {
            errors.salesPrice = 'Sales Price is required when selling this service.';
          }
          if (!this.incomeAccount || this.incomeAccount === '' || this.incomeAccount === '__add_new_account__') {
            errors.incomeAccount = 'Income Account is required when selling this service.';
          }
        }
        if (this.iBuyThisService) {
          if (!this.purchasePrice || this.purchasePrice === '' || this.purchasePrice === 0) {
            errors.purchasePrice = 'Purchase Price is required when buying this service.';
          }
          if (!this.expenseAccount || this.expenseAccount === '' || this.expenseAccount === '__add_new_account__') {
            errors.expenseAccount = 'Expense Account is required when buying this service.';
          }
        }
        // Sales vs purchase comparison only applies when selling (and buying).
        if (this.iSellThisService && this.salesPriceError) {
          errors.salesPrice = this.salesPriceError;
        }
        if (this.iBuyThisService && this.purchasePriceError) {
          errors.purchasePrice = this.purchasePriceError;
        }
      }
      return errors;
    },
    showValidationError(validationErrors) {
      const errorMessages = Object.values(validationErrors)
        .map((message) => `• ${message}`)
        .join('\n');
      this.errorTitle = 'Please Complete Required Fields';
      this.errorMessage = `Please fix the following issues before continuing:\n\n${errorMessages}`;
      this.errorButtonText = 'OK';
      this.showErrorModal = true;
    },
    closeErrorModal() {
      this.showErrorModal = false;
      this.errorMessage = '';
    },
    closeSuccessModal() {
      this.showSuccessModal = false;
      this.successMessage = '';
      if (this.isModal) {
        this.saveAction = null;
        return;
      }
      const companyId = this.companyId;
      if (this.saveAction === 'saveAndClose') {
        this.$router.push({ name: 'VendorItemsList', params: { id: companyId } });
      } else if (this.saveAction === 'saveAndNew') {
        this.resetForm();
      }
      this.saveAction = null;
    },
    closeProfitLossModal() {
      this.showProfitLossModal = false;
    },
    handleSaveAndNew() {
      const allErrors = this.validateAllTabs();
      if (Object.keys(allErrors).length > 0) {
        this.showValidationError(allErrors);
        return;
      }
      this.saveAction = 'saveAndNew';
      this.saveVendorServiceItem();
    },
    handleSaveAndClose() {
      const allErrors = this.validateAllTabs();
      if (Object.keys(allErrors).length > 0) {
        this.showValidationError(allErrors);
        return;
      }
      this.saveAction = 'saveAndClose';
      this.saveVendorServiceItem();
    },
    handleModalSave() {
      const allErrors = this.validateAllTabs();
      if (Object.keys(allErrors).length > 0) {
        this.showValidationError(allErrors);
        return;
      }
      this.saveAction = 'modalSave';
      this.saveVendorServiceItem();
    },
    validateAllTabs() {
      const errors = {};
      if (!this.serviceName || this.serviceName.trim() === '') {
        errors.serviceName = 'Service Name is required.';
      }
      if (this.isSubitem && (!this.subitemOf || this.subitemOf === '')) {
        errors.subitemOf = 'Parent Item is required when Subitem is selected.';
      }
      if (!this.iSellThisService && !this.iBuyThisService) {
        errors.serviceType = 'Please select at least one service type (I sell this service or I buy this service).';
      }
      if (this.iSellThisService) {
        if (!this.salesPrice || this.salesPrice === '' || this.salesPrice === 0) {
          errors.salesPrice = 'Sales Price is required when selling this service.';
        }
        if (!this.incomeAccount || this.incomeAccount === '' || this.incomeAccount === '__add_new_account__') {
          errors.incomeAccount = 'Income Account is required when selling this service.';
        }
      }
      if (this.iBuyThisService) {
        if (!this.purchasePrice || this.purchasePrice === '' || this.purchasePrice === 0) {
          errors.purchasePrice = 'Purchase Price is required when buying this service.';
        }
        if (!this.expenseAccount || this.expenseAccount === '' || this.expenseAccount === '__add_new_account__') {
          errors.expenseAccount = 'Expense Account is required when buying this service.';
        }
      }
      // Sales vs purchase comparison only applies when selling (and buying).
      if (this.iSellThisService && this.salesPriceError) {
        errors.salesPrice = this.salesPriceError;
      }
      if (this.iBuyThisService && this.purchasePriceError) {
        errors.purchasePrice = this.purchasePriceError;
      }
      return errors;
    },
    closeVendorSearchModal() {
      this.showVendorSearchModal = false;
    },
    handleItemsGroupChange(eventOrValue) {
      const selected = this.resolveSelectValue(eventOrValue);
      if (selected === '__create_new__') {
        this.showAddGroupModal = true;
        this.itemsGroup = this.previousItemsGroup || '';
      } else {
        this.itemsGroup = selected;
        this.previousItemsGroup = selected;
      }
    },
    onAddGroupCancel() {
      this.showAddGroupModal = false;
      this.itemsGroup = this.previousItemsGroup || '';
    },
    async onAddGroupOk(group) {
      this.showAddGroupModal = false;
      if (group && group.id) {
        if (!this.itemCategories.some((g) => g.id === group.id)) {
          this.itemCategories.push(group);
        }
        this.itemsGroup = String(group.id);
        this.previousItemsGroup = String(group.id);
      }
    },
    handlePreferredVendorChange(eventOrValue) {
      const selected = this.resolveSelectValue(eventOrValue);
      if (selected === '__add_new_vendor__') {
        this.$router.push({ name: 'AddNewVendor', params: { id: this.companyId } });
        this.preferredVendor = '';
      } else {
        this.preferredVendor = selected;
      }
    },
    handleIncomeAccountChange(eventOrValue) {
      const selected = this.resolveSelectValue(eventOrValue);
      if (selected === '__add_new_account__') {
        this.navigateToNewAccount();
        this.incomeAccount = '';
      } else {
        this.incomeAccount = selected;
      }
    },
    handleExpenseAccountChange(eventOrValue) {
      const selected = this.resolveSelectValue(eventOrValue);
      if (selected === '__add_new_account__') {
        this.navigateToNewAccount();
        this.expenseAccount = '';
      } else {
        this.expenseAccount = selected;
      }
    },
    validatePrices() {
      // Buy-only: ignore sales price entirely (no sales vs purchase comparison).
      if (!this.iSellThisService) {
        this.salesPriceError = '';
      } else if (this.salesPrice !== '' && this.salesPrice != null && (isNaN(this.salesPrice) || Number(this.salesPrice) < 0)) {
        this.salesPriceError = 'Sales Price (USD) must be a non-negative number.';
      } else if (
        this.iBuyThisService &&
        this.purchasePrice !== '' &&
        this.purchasePrice != null &&
        this.salesPrice !== '' &&
        this.salesPrice != null &&
        Number(this.salesPrice) < Number(this.purchasePrice)
      ) {
        // Only compare when both sell and buy are enabled.
        this.salesPriceError = 'Sales Price (USD) should not be less than Purchase Price (USD).';
      } else {
        this.salesPriceError = '';
      }

      if (this.iBuyThisService) {
        if (this.purchasePrice !== '' && this.purchasePrice != null && (isNaN(this.purchasePrice) || Number(this.purchasePrice) < 0)) {
          this.purchasePriceError = 'Purchase Price (USD) must be a non-negative number.';
        } else {
          this.purchasePriceError = '';
        }
      } else {
        this.purchasePriceError = '';
      }

      this.calculateProfitLoss();
    },
    calculateProfitLoss() {
      const salesPrice = Number(this.salesPrice) || 0;
      const purchasePrice = Number(this.purchasePrice) || 0;

      if (
        this.iSellThisService &&
        this.iBuyThisService &&
        salesPrice > 0 &&
        purchasePrice > 0 &&
        !this.salesPriceError &&
        !this.purchasePriceError &&
        !this.isModal
      ) {
        const profitAmount = salesPrice - purchasePrice;
        const profitPercentage = purchasePrice > 0 ? (profitAmount / purchasePrice) * 100 : 0;
        let type;
        let message;

        if (profitAmount > 0) {
          type = 'profit';
          message = `You will make a profit of $${profitAmount.toFixed(2)} on this service`;
        } else if (profitAmount < 0) {
          type = 'loss';
          message = `You will incur a loss of $${Math.abs(profitAmount).toFixed(2)} on this service`;
        } else {
          type = 'break-even';
          message = 'This service will break even (no profit or loss)';
        }

        this.profitLossData = {
          type,
          amount: Math.abs(profitAmount).toFixed(2),
          percentage: Math.abs(profitPercentage).toFixed(1),
          message,
        };
        this.showProfitLossModal = true;
      }
    },
    async saveVendorServiceItem() {
      try {
        const payload = {
          serviceName: this.serviceName,
          isSubitem: this.isSubitem,
          subitemOf: this.isSubitem ? this.subitemOf : null,
          iSellThisService: this.iSellThisService,
          salesDescription: this.salesDescription,
          salesPrice: this.salesPrice,
          incomeAccountId: this.incomeAccount || null,
          taxable: this.taxable,
          commissionItem: this.commissionItem,
          standardCost: this.standardCost,
          itemGroupId: this.itemsGroup || null,
          active: this.active,
          iBuyThisService: this.iBuyThisService,
          purchaseDescription: this.purchaseDescription,
          purchasePrice: this.purchasePrice,
          expenseAccountId: this.expenseAccount || null,
          preferredVendor: this.preferredVendor || null,
          vendorServiceNo: this.vendorServiceNo,
          companyId: this.companyId,
        };
        const res = await ApiService.post('/vendor/service-items', payload);
        const item = res.data;

        if (this.isModal && this.saveAction === 'modalSave') {
          this.$emit('saved', this.mapSavedServiceItem(item));
          this.saveAction = null;
          return;
        }

        this.successTitle = 'Vendor Service Item Created Successfully';
        this.successMessage = `The vendor service item "${this.serviceName}" has been created successfully.`;
        this.successButtonText = 'OK';
        this.showSuccessModal = true;
      } catch (error) {
        this.errorTitle = 'Error';
        this.errorMessage =
          'Error saving Vendor Service Item: ' + (error.response?.data?.error || error.message);
        this.showErrorModal = true;
      }
    },
    mapSavedServiceItem(item) {
      return {
        id: item.id,
        name: item.serviceName,
        type: item.type || 'Service',
        salesPrice: item.purchasePrice ?? item.salesPrice ?? 0,
        purchasePrice: item.purchasePrice,
        preferredVendor: item.preferredVendor,
      };
    },
    cancel() {
      if (this.isModal) {
        this.$emit('close');
        return;
      }
      this.$router.back();
    },
    navigateToNewAccount() {
      this.$router.push(`/company/${this.companyId}/dashboard/new-account`);
    },
    resetForm() {
      this.activeTab = 'basic';
      this.serviceName = '';
      this.isSubitem = false;
      this.subitemOf = '';
      this.iSellThisService = false;
      this.salesDescription = '';
      this.salesPrice = 0.0;
      this.incomeAccount = '';
      this.taxable = true;
      this.commissionItem = false;
      this.standardCost = 0.0;
      this.itemsGroup = '';
      this.previousItemsGroup = '';
      this.active = true;
      this.iBuyThisService = true;
      this.purchaseDescription = '';
      this.purchasePrice = 0.0;
      this.expenseAccount = '';
      this.preferredVendor = '';
      this.vendorServiceNo = '';
      this.salesPriceError = '';
      this.purchasePriceError = '';
    },
  },
};
</script>
